import { component } from 'picoapp';
import { clear, scrollLock } from 'utils/node';
import { debounce } from 'lodash-es';

import productCard from 'lib/product-card';
import ClerkHelper from 'utils/clerk';
import Drawer from 'utils/drawer';

export default component((node, ctx) => {
  const categoryList = node.querySelector('[data-categories]');
  const productsList = node.querySelector('[data-products]');
  const pagesList = node.querySelector('[data-pages]');

  const drawer = node.querySelector('[data-drawer]');
  const searchInput = node.querySelector('[data-search-input]');

  const searchDrawer = Drawer(drawer, node);
  const search = new ClerkHelper(['Search']);

  ctx.on('searchdrawer:toggle', () => {
    searchDrawer.toggle();
    searchInput.focus();
  });

  searchDrawer.on('opened', () => scrollLock());
  searchDrawer.on('closed', () => {
    setTimeout(() => {
      searchInput.blur();
    }, 50);

    scrollLock(false);
  });

  const emptyMessage = (container) => {
    const p = document.createElement('p');
    p.className = 'font-italic text-grey-dark col-span-full';
    p.textContent = window.theme.strings.search.results.none.replace('"_term"', `"${searchInput.value}"`);
    container.appendChild(p);
  };

  const renderCategories = async (categories) => {
    clear(categoryList);

    if (!categories.length) {
      emptyMessage(categoryList);
    } else {
      categories.forEach((item) => {
        const {
          name,
          url,
        } = item;

        categoryList.insertAdjacentHTML('beforeend', `
          <li><a href="${url}">${name}</a></li>
        `);
      });
    }
  };

  const renderProducts = async ({ products }) => {
    clear(productsList);

    if (!products.length) {
      emptyMessage(productsList);
    } else {
      products.forEach((item) => {
        productsList.insertAdjacentHTML(
          'beforeend',
          productCard(item, false, false, false, false, true, 'w-full'),
        );
      });
    }
  };

  const renderPages = async ({ pages }) => {
    clear(pagesList);

    if (!pages.length) {
      emptyMessage(pagesList);
    } else {
      pages.forEach((item) => {
        const {
          title,
          url,
        } = item;

        pagesList.insertAdjacentHTML('beforeend', `
          <li><a href="${url}">${title}</a></li>
        `);
      });
    }
  };

  searchInput.addEventListener('input', debounce(async ({ target }) => {
    const categories = await search.getCategories('search/categories', target.value);
    const pages = await search.getPages('search/pages', target.value);
    const products = await search.getProducts('search/predictive', {
      query: target.value,
      facets: ['categories', 'brands'],
    });

    renderPages(pages);
    renderCategories(categories);
    renderProducts(products);

    window.Clerk('click', '*[data-clerk-product-id]');
    document.dispatchEvent(new CustomEvent('app:mount'));
  }, 250));
});
